import productReload from './product-cards';
import retrieveModals from './ajax-modals';
import closeModalX from './modals';

const productList = document.querySelector('.product-listing');
const cb = document.querySelectorAll("input[type=checkbox]");
const clearFilter = document.querySelector('.clear-filter');

if (productList) {
    for (var i = 0; i < cb.length; i++) {
        cb[i].onclick = function () {
            plist();
        };
    }

    if (clearFilter) {
        clearFilter.addEventListener('click', function () {
            plistReset();
            productReload();
        });
    }
}

function plist() {
    const xhr = new XMLHttpRequest();
    let uri = window.location.pathname;
    uri = uri + "?layouttemplate=raw.cshtml";
    let cbc = document.querySelectorAll("input[type=checkbox]:checked");
    for (var i = 0; i < cbc.length; i++) {
        uri += "&" + cbc[i].name + "=" + cbc[i].value;
    }
    xhr.open("post", uri);
    xhr.onload = function () {
        if (xhr.status === 200) {
            const data = xhr.responseText;
            document.getElementsByClassName("product-listing")[0].innerHTML = data;
            productReload();
            retrieveModals();            
        }
    };
    xhr.send();
}

function plistReset() {
    const xhr = new XMLHttpRequest();
    let uri = window.location.pathname;
    uri = uri + "?layouttemplate=raw.cshtml";

    xhr.open("post", uri);
    xhr.onload = function () {
        if (xhr.status === 200) {
            const data = xhr.responseText;
            document.getElementsByClassName("product-listing")[0].innerHTML = data;
            productReload();
        }
    };
    xhr.send();
}


// WEBPACK FOOTER //
// ./scripts/components/ajax-products.js